export const firebaseConfig = {
  apiKey: 'AIzaSyBTM8beHvLFZx5cgeZ-rdwr8K4vvp0damQ',
  authDomain: 'fir-app-ce0af.firebaseapp.com',
  databaseURL: 'https://fir-app-ce0af.firebaseio.com',
  projectId: 'fir-app-ce0af',
  storageBucket: 'fir-app-ce0af.appspot.com',
  messagingSenderId: '158248257657'
}



// WEBPACK FOOTER //
// ./src/config.js